module.exports = __webpack_public_path__ + "5602149f30a0a0e70bb92ee769e7c946.svg";